@if (draft !== null) {
<div class="row px-3 px-lg-0">
    <div class="col-12 col-sm-6">
        <select class="custom-select border-light2 mb-1" [(ngModel)]="round" (change)="onRoundChange($event)">
            @for (r of rounds(); track trackByIndex(i, r); let i = $index) {
            <option [value]="r">{{ 'web.round' | translate | titlecase }} {{ r }}</option>
            }
        </select>
    </div>
    <div class="col-12 col-sm-6">
        <select class="custom-select border-light2 mb-1" [(ngModel)]="year" (change)="onYearChange($event)">
            @for (y of draft.years; track $index) {
            <option [value]="y.year">
                {{ y.year }}
            </option>
            }
        </select>
    </div>
</div>
<h4 class="head mt-3 ml-2 ml-xl-0">
    {{ 'web.drafts' | translate }} {{ year }}, {{ 'web.round' | translate | titlecase }} {{ round }}
</h4>
<div class="d-flex table-scrollable">
    <div class="table-scrollable__data flex-grow-1">
        <table class="table-scrollable__data__table" data-cy="app-table-left-data">
            <thead>
                <tr>
                    <th class="table-scrollable__table-th text-center">Pick</th>
                    <th class="table-scrollable__table-th text-center" colspan="2">
                        {{ 'web.team' | translate }}
                    </th>
                    <th class="table-scrollable__table-th text-center" colspan="2">
                        {{ 'web.player' | translate }}
                    </th>
                    <th class="table-scrollable__table-th">
                        {{ 'web.position' | translate }}
                    </th>
                    <th class="table-scrollable__table-th">
                        {{ 'web.school' | translate }}
                    </th>
                    <th class="table-scrollable__table-th">
                        {{ 'web.trade' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (p of draft.data?.picks; track p) {
                <tr class="table-scrollable__table-row">
                    <td class="table-scrollable__table-td text-center">
                        {{ p.number }} @if (p.overall !== p.number) {
                        <span class="small">({{ p.overall }})</span>
                        }
                    </td>
                    <td class="table-scrollable__table-td text-center" style="width: 55px">
                        @if (p.participant.image !== null) {
                        <img
                            [src]="p.participant.image"
                            [alt]="p.participant.name"
                            height="40"
                            width="40"
                            style="object-fit: contain"
                            class="mr-1"
                        />
                        } @if (p.participant.image === null) {
                        <img
                            [src]="'/img/sports/' + sportName + '.png'"
                            [alt]="p.participant.name"
                            height="40"
                            width="40"
                            style="object-fit: contain"
                            class="mr-1"
                        />
                        }
                    </td>
                    <td class="table-scrollable__table-td">
                        <a
                            [routerLink]="['/page/sport/participant', sportName + '-' + sportId, p.participant.id]"
                            class="text-reset table-scrollable-team"
                        >
                            {{ p.participant.name }}
                        </a>
                    </td>
                    <td class="table-scrollable__table-td text-center" style="width: 55px">
                        <div class="img-circle img-circle--40 mr-3 rounded-circle">
                            <img
                                (error)="imageError($event, 'avatar')"
                                [attr.alt]="p.prospect.player?.name ?? p.prospect.name"
                                [src]="'/assets/players/photos/' + p.prospect.player?.id + '.png'"
                                height="40"
                                loading="lazy"
                            />
                        </div>
                    </td>
                    <td class="table-scrollable__table-td">
                        @if (p.prospect.player) {
                        <a
                            [routerLink]="['/page/sport/player', sportName + '-' + sportId, p.prospect.player.id]"
                            class="text-reset table-scrollable-team"
                        >
                            {{ p.prospect.player.name ?? p.prospect.name }}
                        </a>
                        } @else {
                        {{ p.prospect.name }}
                        }
                    </td>
                    <td class="table-scrollable__table-td">
                        {{ p.prospect.position }}
                    </td>
                    <td class="table-scrollable__table-td">
                        {{ p.prospect.team_name }}
                    </td>
                    <td class="table-scrollable__table-td">
                        @if (p.traded) {
                        <i class="fas fa-exchange-alt"></i>
                        @for (t of tradesChain(p); track t; let isLast = $last) {
                        {{ t.alias }}
                        @if (!isLast) {
                        <i class="fas fa-angle-right"></i>
                        } } }
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>
} @else {
<app-placeholder-table></app-placeholder-table>
}
